import React from 'react'

const TutorialsLoader = () => {
    return (
        <div className='d-flex flex-column justify-content-center align-items-center mb-5'>
            <div className='d-flex flex-column justify-content-center align-items-center gap-4 w-50 rounded mt-4' style={{minWidth: "320px", maxWidth: "685px", height: "300px", border: "1px solid #AEAFBA", backgroundColor: "rgba(0, 0, 0, 0.3)"}}>
                {/* Map placeholder 6 times */}
                {[...Array(6)].map((_, index) => (
                    <div key={index} className='tutorials_placeholder col-10'></div>
                ))}

            </div>
            <div className='d-flex flex-column justify-content-center align-items-center gap-4 w-50 rounded mt-4' style={{minWidth: "320px", maxWidth: "685px", height: "300px", border: "1px solid #AEAFBA", backgroundColor: "rgba(0, 0, 0, 0.3)"}}>
                {[...Array(6)].map((_, index) => (
                    <div key={index} className='tutorials_placeholder col-10'></div>
                ))}
            </div>
            <div className='d-flex flex-column justify-content-center align-items-center gap-4 w-50 rounded mt-4' style={{minWidth: "320px", maxWidth: "685px", height: "300px", border: "1px solid #AEAFBA", backgroundColor: "rgba(0, 0, 0, 0.3)"}}>
                {[...Array(6)].map((_, index) => (
                    <div key={index} className='tutorials_placeholder col-10'></div>
                ))}
            </div>
        </div>
  )
}

export default TutorialsLoader